import { IconProps } from './icons';

export const CrossIcon = ({ color = '#0085FF', height = 19, width = 19 }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 19 19" fill="none">
      <path
        d="M0.893934 16.9442C0.865804 16.9723 0.85 17.0105 0.85 17.0503C0.85 17.09 0.865804 17.1282 0.893934 17.1563L1.84368 18.1061C1.90226 18.1646 1.99723 18.1646 2.05581 18.1061L9.5 10.6619L16.9442 18.1061C17.0028 18.1646 17.0977 18.1646 17.1563 18.1061L18.1061 17.1563C18.1646 17.0977 18.1646 17.0028 18.1061 16.9442L10.6619 9.5L18.1061 2.05581C18.1646 1.99723 18.1646 1.90226 18.1061 1.84368L17.1563 0.893934C17.1282 0.865804 17.09 0.85 17.0503 0.85C17.0105 0.85 16.9723 0.865804 16.9442 0.893934L9.5 8.33812L2.05581 0.893934C2.02768 0.865804 1.98953 0.85 1.94975 0.85C1.90997 0.85 1.87181 0.865804 1.84368 0.893934L0.893934 1.84368C0.865804 1.87181 0.85 1.90997 0.85 1.94975C0.85 1.98953 0.865804 2.02768 0.893934 2.05581L8.33812 9.5L0.893934 16.9442Z"
        fill={color}
        stroke={color}
        strokeWidth="0.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
